import { create } from 'zustand'
import { persist } from 'zustand/middleware'

export interface ScheduledMessage {
  id: string
  chatId: string
  text: string
  mediaIds?: string[]
  replyToId?: string
  scheduledFor: string // ISO string
  createdAt: string
}

interface ScheduledState {
  messages: ScheduledMessage[]
  add: (msg: Omit<ScheduledMessage, 'id' | 'createdAt'>) => void
  remove: (id: string) => void
  removeDue: (ids: string[]) => void
}

export const useScheduledStore = create<ScheduledState>()(
  persist(
    (set) => ({
      messages: [],
      add: (msg) =>
        set((s) => ({
          messages: [
            ...s.messages,
            {
              ...msg,
              id: `sched_${Date.now()}_${Math.random().toString(36).slice(2)}`,
              createdAt: new Date().toISOString(),
            },
          ],
        })),
      remove: (id) => set((s) => ({ messages: s.messages.filter((m) => m.id !== id) })),
      removeDue: (ids) => set((s) => ({ messages: s.messages.filter((m) => !ids.includes(m.id)) })),
    }),
    { name: 'ggram-scheduled' },
  ),
)
